import { UpdateInvoicePayload } from "../Interface/Invoice";
import axiosInstance from "./axiosInstance";



export const fetchInvoices = async (filters: Record<string, string> | null = null) => {
  try {
    const response = await axiosInstance.get("/GetAllInvoices", {
      params: filters ?? undefined,
    });
    console.log("Filtered API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching invoices:", error);
    throw error;
  }
};



export const deleteInvoice = async (invoiceId: number) => {
  try {
    const response = await axiosInstance.delete(`/DeleteInvoice/${invoiceId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting invoice:", error);
    throw error;
  }
};

export const fetchCustomers = async (searchFilters: Record<string, string> = {}) => {
  try {
    const response = await axiosInstance.get("/customers", {
      params: searchFilters,
    });
    console.log("Fetched customers:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

export const fetchStatus = async (filters: Record<string, string> | null = null) => {
  try {
    const response = await axiosInstance.get("/GetInvoiceStatus", {
      params: filters ?? undefined,
    });
    console.log("Filtered API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching status:", error);
    throw error;
  }
};


export const fetchProjects = async (filters: Record<string, string> = {}) => {
  try {
    const response = await axiosInstance.get("/Projects", {
      params: filters,
    });
    console.log("Fetched projects:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching Projects:", error);
    throw error;
  }
};

export const fetchGetMonths = async () => {
  try {
    const response = await axiosInstance.get("/GetMonths");
    return response.data;
  } catch (error) {
    console.error("Error fetching months:", error);
    throw error;
  }
};

export const fetchGetYears = async () => {
  try {
    const response = await axiosInstance.get("/GetYears");
    return response.data;
  } catch (error) {
    console.error("Error fetching years:", error);
    throw error;
  }
};

export const GetInvoiceDetailsByID = async (id: number) => {
  try {
    const response = await axiosInstance.get(`/GetInvoiceDetailsByID/${id}`);
    console.log("bye" + JSON.stringify(response));
    return response.data;
  } catch (error) {
    console.error("Error fetching invoice details:", error);
    throw error;
  }
};

export const getAllCustomers = async () => {
  try {
    const response = await axiosInstance.get(`/customers`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all customers:", error);
    throw error;
  }
};

export const fetchInvoiceId = async (filters: Record<string, string> | null = null) => {
  try {
    console.log(filters);
    const response = await axiosInstance.get("/employees");
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching employees for invoice:", error);
    throw error;
  }
};


export const GetNewInvoiceDetails = async (
  customerId: number,
  projectId: number,
  month: string,
  year: string
) =>
  axiosInstance.get("/GetNewInvoiceDetails", {
    params: { customerId, projectId, month, year },
  });





export const GetProjectByCustomerId = async (customerId: number) => {
  try {
    const response = await axiosInstance.get("/GetProjectByCustomerId", {
      params: { customerId },
    });
    return response;
  } catch (error) {
    console.error(`Error fetching projects for customer ${customerId}:`, error);
    throw error;
  }
};


export const CreateInvoice = async (invoiceData: any) => {
      console.log("parthi" + JSON.stringify(invoiceData))
  try {
    const response = await axiosInstance.post("/CreateInvoice", invoiceData);
    return response;
  } catch (error) {
    console.error("CreateInvoice error:", error);
    throw error;
  }
};



export const UpdateInvoice = (
  invoiceId: number,
  payload: UpdateInvoicePayload
) => {
  return axiosInstance.put(`/UpdateInvoice`, payload);
};
